import en from './strings.en';

const ru = {
    empty: 'Список пуст',
    participantsCount: '{{count}} уч.',
    lackOfRights: 'Недостаточно прав для управления\nсписком. Чтобы получить права,\nобратитесь к руководителю',
    selectedFirmAlreadyAdded: 'Выбранная фирма уже есть\nв этом списке',
    selectedFirmsAlreadyAdded: 'Все выбранные фирмы уже\nесть в этом списке',
    scrollAddedFirms: '{{count}} {{firmPlural}} уже есть в списке.',
    willAddFirms: ' Добавим {{count}} {{firmPlural}}'
};

export default { ru, en: { ...ru, ...en} };
